import { hidde_preloader } from "@cozumel-reef-maps/web_general/js/ui/preloader.js";
import { login } from "@cozumel-reef-maps/web_general/js/ui/general.js";



export default function initLogin(container) {
    console.log("Se ha cargado el módulo de Login.");
    
   login();
   hidde_preloader();

   
}

